export default "__VITE_ASSET__DPv0Au4i__"